var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"slide-up",attrs:{"type":"button","aria-label":"Наверх"},on:{"click":_vm.scrollToTop}},[_c('span',{staticClass:"slide-up__arrow"}),_vm._v(" "),_c('span',[_vm._v("Наверх")])])
}
var staticRenderFns = []

export { render, staticRenderFns }